import { Box } from '@mui/system';
import { useSelector } from 'react-redux';
import logo from '../../../assets/2N_Logo_RGB_White.svg';
import LanguageSelect from '../../../components/HeaderPublic/LanguageSelect';
import * as localizationSelectors from '../../../modules/localization/selectors';

const styles = {
  img: {
    display: 'block',
    height: 44,
    objectFit: 'contain',
    width: 44,
  },
  root: {
    backgroundColor: 'landingPage.headerBackground',
    height: 64,
    width: '100%',
    zIndex: 15,
  },
};

export function AppDownloadHeader() {
  const currentUserLang = useSelector(localizationSelectors.getCurrentUserLanguage);

  return (
    <Box alignItems="center" component="header" display="flex" justifyContent="space-between" sx={styles.root}>
      <Box alignItems="center" display="flex">
        <a
          href={`https://www.2n.com/${currentUserLang}/`}
          style={{ display: 'block', marginLeft: 16, marginRight: 16 }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img alt="2N" src={logo} style={{ display: 'block', height: 44, objectFit: 'contain', width: 44 }} />
        </a>
      </Box>
      <Box alignItems="center" component="nav" display="flex">
        <LanguageSelect />
      </Box>
    </Box>
  );
}
